import { SelectControl } from './Control';
import { SelectOption } from './Option';
import { SelectControlMulti } from './multi-select/ControlMulti';
import { SelectOptionMulti } from './multi-select/OptionMulti';

export const Select = {
  Control: SelectControl,
  ControlMulti: SelectControlMulti,
  Option: SelectOption,
  OptionMulti: SelectOptionMulti,
} as const;

export { type SelectControlProps } from './Control';
